import { ReactNode, useEffect } from 'react';
import Header from './layout/Header';

interface AdminLayoutProps {
  children: ReactNode;
  className?: string;
}

const AdminLayout = ({ children, className = "" }: AdminLayoutProps) => {
  useEffect(() => {
    // Check if Marker.io script is already loaded
    if (document.querySelector('script[src="/marker.js"]')) {
      return;
    }

    // Add Marker.io script to the page
    const script = document.createElement('script');
    script.src = '/marker.js';
    script.async = true;
    document.head.appendChild(script);

    return () => {
      // Clean up script when component unmounts
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#F3F5F7] noise-texture">
      {/* Subtle atmospheric gradient */}
      <div className="fixed inset-0 pointer-events-none">
        <div className="absolute -top-64 -right-64 w-[800px] h-[800px] rounded-full bg-gradient-to-br from-[#18A5F9]/[0.03] to-transparent blur-3xl"></div>
        <div className="absolute -bottom-64 -left-64 w-[600px] h-[600px] rounded-full bg-gradient-to-tr from-[#18A5F9]/[0.02] to-transparent blur-3xl"></div>
      </div>

      <div className="relative z-10">
        <Header />
        <main className={`max-w-7xl mx-auto px-6 py-8 ${className}`}>
          {children}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
